// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/1aea0d4366d0527889e4.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e3853f6fbd41ccb698d5","125":"f6628c084543f889a31f","126":"9b1116f2d686fa241e3e"}[chunkId] + ".chunk.js";
};